module.exports = __webpack_public_path__ + "static/img/rosete-restauration.0dc82f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rosete-restauration.jpg
// module id = o/Ut
// module chunks = 1